import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import RemovalHero from '../components/removal/RemovalHero';
import RemovalForm from '../components/removal/RemovalForm';
import styles from './RemovalPage.module.css';

// Public "Request Removal/Deletion (Opt-Out of Sale and Sharing)" page.
export default function RemovalPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <RemovalHero />
        <RemovalForm />
      </main>
      <LandingFooter />
    </div>
  );
}
